import { useQuery, keepPreviousData } from '@tanstack/react-query'
import {
  getAdminJurisdictions,
  getAdminPubAuthorities,
  getAdminDocuments,
  getDocumentViewCoverage,
} from '@/api/adminService'

export function useAdminJurisdictions() {
  return useQuery({
    queryKey: ['admin', 'database', 'jurisdictions'],
    queryFn: getAdminJurisdictions,
  })
}

export function useAdminPubAuthorities() {
  return useQuery({
    queryKey: ['admin', 'database', 'pub-authorities'],
    queryFn: getAdminPubAuthorities,
  })
}

export function useDocumentViewCoverage() {
  return useQuery({
    queryKey: ['admin', 'database', 'document-view-coverage'],
    queryFn: getDocumentViewCoverage,
    staleTime: 60_000,
  })
}

export function useAdminDocuments(
  page: number,
  pageSize: number,
  search: string,
  jurisdictionUuid?: string,
  pubAuthorityUuid?: string,
) {
  return useQuery({
    queryKey: ['admin', 'database', 'documents', page, pageSize, search, jurisdictionUuid, pubAuthorityUuid],
    queryFn: () => getAdminDocuments({
      page,
      page_size: pageSize,
      search: search || undefined,
      jurisdiction_uuid: jurisdictionUuid || undefined,
      pub_authority_uuid: pubAuthorityUuid || undefined,
    }),
    placeholderData: keepPreviousData,
  })
}
